export enum FlightBrandedAttributeStatus {
    Included = 'Included',
    NotOffered = 'NotOffered',
    Chargeable = 'Chargeable',
}

export enum FlightBrandedAttributeType {
    CarryOn = 'CarryOn',
    ChauffeurTransfer = 'ChauffeurTransfer',
    CheckedBag = 'CheckedBag',
    ExtraLegroom = 'ExtraLegroom',
    InFlightEntertainment = 'InFlightEntertainment',
    LieFlatSeat = 'LieFlatSeat',
    LoungeAccess = 'LoungeAccess',
    None = 'None',
    Meals = 'Meals',
    MileageAccrual = 'MileageAccrual',
    PersonalItem = 'PersonalItem',
    PremiumSeat = 'PremiumSeat',
    PriorityBaggage = 'PriorityBaggage',
    PriorityBoarding = 'PriorityBoarding',
    PriorityCheckIn = 'PriorityCheckIn',
    PrioritySecurity = 'PrioritySecurity',
    PriorityServices = 'PriorityServices',
    Rebooking = 'Rebooking',
    Refund = 'Refund',
    SeatAssignment = 'SeatAssignment',
    Upgrades = 'Upgrades',
    USB = 'USB',
    WiFi = 'WiFi',
}

export interface BaggageIncluded {
    carryOnBaggage: string[];
    checkedBag: string[];
}
